import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Loader from '../loader';

function DialogButton({ onClick, disabled = false, isLoading = false, children, ...otherProps }) {
  const classes = classNames('ws-ui-dialog-btn', {
    'ws-ui-dialog-btn--loading': !disabled && isLoading,
  });

  const loaderComponent = isLoading ? (
    <div className="ws-ui-dialog-btn__loader-wrapper">
      <Loader />
    </div>
  ) : null;

  return (
    <button
      className={classes}
      disabled={disabled}
      onClick={!isLoading ? onClick : null}
      {...otherProps}
    >
      {children}
      {!disabled && loaderComponent}
    </button>
  );
}

DialogButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
};

export default DialogButton;
